import type { LaboratoryResultBeritaAcaraEntry } from '../../api/strapiCrm';

export type LaboratoryResultBidangGroup = {
  bidangLabel: string;
  titikList: LaboratoryResultBeritaAcaraEntry[];
};

export function groupBeritaAcaraByBidangAndTitik(
  beritaAcara: LaboratoryResultBeritaAcaraEntry[],
): LaboratoryResultBidangGroup[] {
  const byBidang = new Map<string, LaboratoryResultBeritaAcaraEntry[]>();
  for (const ba of beritaAcara) {
    const key = ba.bidang_label?.trim() || '—';
    const list = byBidang.get(key) ?? [];
    list.push(ba);
    byBidang.set(key, list);
  }

  return [...byBidang.entries()]
    .sort(([a], [b]) => a.localeCompare(b, 'id'))
    .map(([bidangLabel, entries]) => ({
      bidangLabel,
      titikList: [...entries].sort((a, b) => a.point_index - b.point_index),
    }));
}
